import { useSelector, shallowEqual } from 'react-redux';
import findIndex from 'lodash/findIndex';

// at least one image
// const apertureCount = get(findLast(layouts, { id: layoutId }), 'layout', []).length;
// return !!(objects.reduce((prev, curr, index) => (index < apertureCount && curr && curr.id ? (prev + 1) : prev), 0) > 0);
const useOneImageLoaded = () => useSelector(({ scene: { objects } }) => objects && findIndex(objects, (object) => object.imageId || object.image?.id) >= 0, shallowEqual);

export default useOneImageLoaded;
